// extracted by mini-css-extract-plugin
module.exports = {"expandListButton":"AccordionButton_expandListButton__2cGhB","expandIcon":"AccordionButton_expandIcon__2xJoc","expanded":"AccordionButton_expanded__2nOm2"};